<template>
  <div class="row">
    <div class="col-12">
      <div class="custom-items-two">
        <div class="row">
          <div v-if="quote_data != undefined" class="col-12 d-flex flex-column">
            <table class="w-100">
              <tr
                class="principal-row-table"
                v-bind:style="{
                  backgroundColor:
                    settings_style.colors != undefined
                      ? settings_style.colors[0].color_value
                      : 'white',
                }"
              >
                <th class="py-2 pl-3" style="width: 65%; border-left:0.5px #929497 solid;">Descripción</th>
                <th class="text-center">Precio unitario</th>
                <th class="text-center">Cantidad</th>
                <th class="text-center" style="border-right:0.5px #929497 solid;">Total sin IVA</th>
              </tr>
              <tr v-for="(product, index) in this.items" :key="index">
                <td
                  class="table-item p-3 pr-2"
                  v-if="product.type == 'producto'"
                >
                  <div class="d-flex align-items-start">
                    <div v-if="product.optional.active">
                      <div class="mr-2 mt-2">
                        <div class="em-check-cont">
                          <label class="container-check radio">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              :id="'optional_' + product.id"
                              v-model="product.optional.select"
                              checked="false"
                              :disabled="product.is_client_select == 0 || quote_data.status == 4 || quote_data.status == 7"
                              @click="
                                product.optional.select = !product.optional
                                  .select
                              "
                            />
                            <span class="checkmark radio"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex flex-column ml-3">
                      <small v-if="product.sku != null && product.sku != undefined" v-bind:class="{'text-muted': product.is_client_select == 0 && quote_data.status == 4 }">{{ product.sku }}</small>
                      <span>
                        <b style="font-size:18px;" v-bind:class="{'text-muted': product.is_client_select == 0 && quote_data.status == 4 }" v-bind:style="{color:settings_style.colors != undefined? settings_style.colors[3].color_value: 'white',}">{{ product.title }}</b>
                      </span>
                      <div class="content-html" v-html="product.description"
                        v-bind:style="{color:settings_style.colors != undefined? settings_style.colors[4].color_value: 'white',}"
                        v-bind:class="{'text-muted': product.is_client_select == 0 && quote_data.status == 4 }">
                      </div>
                      <div class="d-flex flex-column">
                        <div class="d-flex flex-row flex-wrap">
                          <lightbox
                            :images="
                              product.attachments.filter(
                                (item) => item.type === 'image'
                              )
                            "
                            v-if="product.attachments.length > 0"
                          ></lightbox>
                        </div>
                        <div class="d-flex flex-row flex-wrap">
                          <div
                            v-for="(file, index) in product.attachments.filter(
                              (item) => item.type === 'file'
                            )"
                            :key="index"
                            class="mb-3"
                          >
                            <a v-bind:href="file.base64" target="_blank">
                              <div class="d-flex">
                                <img
                                  class="mr-2"
                                  src="@/assets/icons/PDF.svg"
                                />
                                <div
                                  style="
                                    border: 1px solid #030303;
                                    border-radius: 9px;
                                    padding: 3px 4px;
                                  "
                                >
                                  {{ file.fileName }}
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td
                  class="table-item text-center"
                  v-if="product.type == 'producto'"
                >
                  <span
                    v-bind:class="{'text-muted': product.is_client_select == 0 && quote_data.status == 4 }"
                    v-bind:style="{color:settings_style.colors != undefined? settings_style.colors[4].color_value: 'white',}"
                  >
                    {{ product.price | currency }}
                  </span>
                </td>
                <td
                  class="table-item text-center"
                  v-if="product.type == 'producto'"
                >
                  <div
                    class="input-group-prepend d-flex flex-column align-items-center justify-content-center"
                    v-if="product.quantity.edit"
                  >
                    <input
                      :id="'qty' + index"
                      type="number"
                      min="1"
                      autocomplete="off"
                      style="width: 70px"
                      class="text-center form-control shadow-sm"
                      placeholder="0"
                      :disabled="product.is_client_select == 0 || quote_data.status == 4 || quote_data.status == 7"
                      v-on:change="
                        calculate(product.quantity.amount, 'qty', index)
                      "
                      v-model="product.quantity.amount"
                    />
                    <small for="qty" v-bind:class="{'text-muted': product.is_client_select == 0 && quote_data.status == 4 }">Cantidad editable</small>
                  </div>
                  <span v-else v-bind:class="{'text-muted': product.is_client_select == 0 && quote_data.status == 4 }">{{ product.quantity.amount }}</span>
                </td>
                <td
                  class="table-item text-center font-weight-bold strong-text"
                  v-if="product.type == 'producto'"
                >
                  <div
                    class="d-flex flex-column justify-content-center align-items-center"
                  >
                    <strong
                      v-bind:class="{'text-muted': product.is_client_select == 0 && quote_data.status == 4 }"
                      v-bind:style="{color:settings_style.colors != undefined? settings_style.colors[3].color_value: 'white',}"
                      >{{ product.total | currency }}
                    </strong>

                    <LabelDiscount
                      v-if="product.discount.active"
                      :discount="product.discount.amount"
                      :class="{'text-muted': product.is_client_select === 0 && quote_data.status === 4}"
                      :style="{color : settings_style.colors != undefined ? settings_style.colors[4].color_value : 'white'}"
                    />

                    <LabelCommission
                      v-if="product.commission.active"
                      :commission="product.commission.amount"
                      :class="{'text-muted': product.is_client_select === 0 && quote_data.status === 4}"
                      :style="{color : settings_style.colors != undefined ? settings_style.colors[4].color_value : 'white'}"
                    />

                    <small
                      v-bind:class="{'text-muted': product.is_client_select == 0 && quote_data.status == 4 }"
                      v-bind:style="{color:settings_style.colors != undefined? settings_style.colors[4].color_value: 'white',}"
                      v-if="
                        product.suscription.frequency != null &&
                        product.suscription.frequency != ''
                      "
                      style="text-transform: uppercase"
                    >
                      {{ product.suscription.frequency | getTimeString }}
                      <br />
                      POR {{ product.suscription.repetition }}
                      {{ product.suscription.frequency }}
                    </small>
                  </div>
                </td>
                <td
                  class="p-3 pr-2"
                  colspan="4"
                  v-if="product.type != 'producto'"
                >
                  <div class="d-flex flex-column ml-3">
                    <span>
                      <b style="font-size:18px;" v-bind:style="{color:settings_style.colors != undefined? settings_style.colors[3].color_value: 'white',}">{{ product.title }}</b>
                    </span>
                    <div
                      class="content-html"
                      v-html="product.description"
                      v-bind:style="{
                        color:
                          settings_style.colors != undefined
                            ? settings_style.colors[4].color_value
                            : 'white',
                      }"
                    ></div>
                    <div class="d-flex flex-column">
                      <div class="d-flex flex-row flex-wrap">
                        <lightbox
                          :images="
                            product.attachments.filter(
                              (item) => item.type === 'image'
                            )
                          "
                          v-if="product.attachments.length > 0"
                        ></lightbox>
                      </div>
                      <div class="d-flex flex-row flex-wrap">
                        <div
                          v-for="(file, index) in product.attachments.filter(
                            (item) => item.type === 'file'
                          )"
                          :key="index"
                          class="mb-3"
                        >
                          <a v-bind:href="file.base64" target="_blank">
                            <div class="d-flex">
                              <img class="mr-2" src="@/assets/icons/PDF.svg" />
                              <div
                                style="
                                  border: 1px solid #030303;
                                  border-radius: 9px;
                                  padding: 3px 4px;
                                "
                              >
                                {{ file.fileName }}
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </table>

            <!-- Seccion de suscripciones -->
            <div class="align-self-end mt-5 d-flex flex-column justify-content-end" v-for="(item, index) in suscriptions" :key="index">
              <table class="table-body-two">
                <!-- SUBTOTAL -->
                <tr>
                  <th class="px-4 strong-text text-right">
                    <div class="d-flex flex-column">
                      <span
                        v-bind:style="{
                          color:
                            settings_style.colors != undefined
                              ? settings_style.colors[3].color_value +
                                ' !important'
                              : 'white',
                        }"
                        >Subtotal:</span
                      >
                      <small
                        class="text-muted"
                        style="font-size: 10px"
                        v-bind:style="{
                          color:
                            settings_style.colors != undefined
                              ? settings_style.colors[4].color_value +
                                ' !important'
                              : 'white',
                        }"
                        v-if="(item.price * item.discount.amount) / 100 > 0"
                        >Incluye un descuento de
                        {{
                          ((item.price * item.discount.amount) / 100) | currency
                        }}</small
                      >
                    </div>
                  </th>
                  <td
                    class="px-4 text-right"
                    v-bind:style="{
                      color:
                        settings_style.colors != undefined
                          ? settings_style.colors[4].color_value + ' !important'
                          : 'white',
                    }"
                  >
                    {{ item.total | currency }}
                  </td>
                </tr>

                <!-- DISCOUNT -->
                <tr v-if="quote_data.discount">
                  <th
                    class="px-4 strong-text text-right"
                    v-bind:style="{
                      color:
                        settings_style.colors != undefined
                          ? settings_style.colors[3].color_value + ' !important'
                          : 'white',
                    }"
                  >
                    Descuento:
                  </th>
                  <td
                    class="px-4 text-right"
                    v-bind:style="{
                      color:
                        settings_style.colors != undefined
                          ? settings_style.colors[4].color_value + ' !important'
                          : 'white',
                    }"
                  >
                    {{ (item.total * (quote_data.discount / 100)) | currency }}
                  </td>
                </tr>

                <!-- TAX -->
                <tr class="last-row">
                  <th
                    class="px-4 pb-3 strong-text text-right"
                    v-bind:style="{
                      color:
                        settings_style.colors != undefined
                          ? settings_style.colors[3].color_value + ' !important'
                          : 'white',
                    }"
                  >
                    IVA {{ quote_data.tax_value }}%:
                  </th>
                  <td
                    class="px-4 pb-3 text-right"
                    v-bind:style="{
                      color:
                        settings_style.colors != undefined
                          ? settings_style.colors[4].color_value + ' !important'
                          : 'white',
                    }"
                  >
                   {{
                      item.tax
                        ? item.total *
                          (1 - quote_data.discount / 100) *
                          (quote_data.tax_value / 100)
                        : 0 | currency
                    }}
                  </td>
                </tr>

                <!-- TOTAL -->
                <tr
                  class="principal-row-table"
                  v-bind:style="{
                    backgroundColor:
                      settings_style.colors != undefined
                        ? settings_style.colors[0].color_value
                        : 'white',
                  }"
                >
                  <th class="px-4 py-2 text-right">
                    <div class="d-flex flex-column">
                      <small class="text-uppercase">Cobro recurrente</small>
                      <span> TOTAL: </span>
                    </div>
                  </th>

                  <th class="px-4 py-2 text-right">
                    <div class="d-flex flex-column">
                      <small style="text-transform: uppercase; font-size: 10px">
                        {{ item.suscription.frequency | getTimeString }} POR
                        {{ item.suscription.repetition }}
                        {{ item.suscription.frequency }}
                      </small>

                      <b style="font-size:20px;">
                        {{ getSuscriptionTotal(item.total, item.tax) | currency }}
                      </b>
                    </div>
                  </th>
                </tr>
              </table>
            </div>

            <!-- Seccion de subtotal -->
            <div v-if="hasProducts" class="align-self-end mt-5 d-flex flex-column justify-content-end">
              <small class="selected-options-label text-right mb-3 px-4" v-if="optionals && optionals > 0"
                v-bind:style="{
                  color:
                    settings_style.colors != undefined
                      ? settings_style.colors[4].color_value + ' !important'
                      : 'white',
                }"
              >
                OPCIONES SELECCIONADAS: {{ optionalsSelected }} DE {{ optionals }}
              </small>

              <table class="table-body-two">
                <tr>
                  <th class="px-4 strong-text text-right">
                    <div class="d-flex flex-column">
                      <span
                        v-bind:style="{
                          color:
                            settings_style.colors != undefined
                              ? settings_style.colors[3].color_value +
                                ' !important'
                              : 'white',
                        }"
                      >
                        Subtotal:
                      </span>

                      <small
                        class="text-muted"
                        v-if="discountItems > 0"
                        style="font-size: 10px"
                        v-bind:style="{
                          color:
                            settings_style.colors != undefined
                              ? settings_style.colors[4].color_value +
                                ' !important'
                              : 'white',
                        }"
                      >
                        Incluye un descuento de {{ discountItems | currency }}
                      </small>
                    </div>
                  </th>

                  <td
                    class="px-4 text-right"
                    v-bind:style="{
                      color:
                        settings_style.colors != undefined
                          ? settings_style.colors[4].color_value + ' !important'
                          : 'white',
                    }"
                  >
                    {{ subtotal | currency }} {{ quote_data.details.currency }}
                  </td>
                </tr>

                <tr v-if="quote_data.discount">
                  <th
                    class="px-4 strong-text text-right"
                    v-bind:style="{
                      color:
                        settings_style.colors != undefined
                          ? settings_style.colors[3].color_value + ' !important'
                          : 'white',
                    }"
                  >
                    Descuento {{ quote_data.discount }}%:
                  </th>

                  <td
                    class="px-4 text-right"
                    v-bind:style="{
                      color:
                        settings_style.colors != undefined
                          ? settings_style.colors[4].color_value + ' !important'
                          : 'white',
                    }"
                  >
                    {{ justDiscount | currency }}
                    {{ quote_data.details.currency }}
                  </td>
                </tr>

                <tr class="last-row">
                  <th
                    class="px-4 pb-3 strong-text text-right"
                    v-bind:style="{
                      color:
                        settings_style.colors != undefined
                          ? settings_style.colors[3].color_value + ' !important'
                          : 'white',
                    }"
                  >
                    IVA {{ quote_data.tax_value }}%:
                  </th>
                  <td
                    class="px-4 pb-3 text-right"
                    v-bind:style="{
                      color:
                        settings_style.colors != undefined
                          ? settings_style.colors[4].color_value + ' !important'
                          : 'white',
                    }"
                  >
                    {{ justTaxes | currency }} {{ quote_data.details.currency }}
                  </td>
                </tr>
                <tr
                  class="principal-row-table"
                  v-bind:style="{
                    backgroundColor:
                      settings_style.colors != undefined
                        ? settings_style.colors[0].color_value
                        : 'white',
                  }"
                >
                  <th class="px-4 py-2 text-right">
                    <div class="d-flex flex-column">
                      <small class="text-uppercase">Cobro único</small>
                      <span> TOTAL: </span>
                    </div>
                  </th>
                  <th class="px-4 py-2 text-right" style="font-size:20px;">
                    {{ getTotal | currency }} {{ quote_data.details.currency }}
                  </th>
                </tr>
              </table>
            </div>
          </div>

          <!-- Para preview -->
          <div v-else class="col-12 d-flex flex-column">
            <table class="w-100">
              <tr
                class="principal-row-table"
                v-bind:style="{
                  backgroundColor:
                    settings_style.colors != undefined
                      ? settings_style.colors[0].color_value
                      : 'white',
                }"
              >
                <th class="py-2 pl-3" style="width: 65%; border-left:0.5px #929497 solid;">Descripción</th>
                <th class="text-center">Precio unitario</th>
                <th class="text-center">Cantidad</th>
                <th class="text-center">Total sin IVA</th>
              </tr>
              <tr>
                <td class="table-item p-3 pr-2">
                  <div class="d-flex align-items-start">
                    <div>
                      <div class="mr-2 mt-2">
                        <div class="em-check-cont">
                          <label class="container-check radio">
                            <input class="form-check-input" type="checkbox" :id="'optional_test'" checked="false"/>
                            <span class="checkmark radio"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex flex-column ml-3">
                      <span style="font-size:18px;" class="d-block font-weight-bold strong-text" v-bind:style="{ color: settings_style.colors != undefined ? settings_style.colors[3].color_value + ' !important' : 'white',}">Ejemplo de producto</span>
                      <div v-bind:style="{ color: settings_style.colors != undefined ? settings_style.colors[4].color_value + ' !important' : 'white', }">Esta es la descripción del producto. Podrás agregarle formato al texto (negritas, itálicas, ligas etc) cuando crees una cotización.</div>
                    </div>
                  </div>
                </td>
                <td
                  class="table-item text-center"
                  v-bind:style="{
                    color:
                      settings_style.colors != undefined
                        ? settings_style.colors[4].color_value + ' !important'
                        : 'white',
                  }"
                >
                  $50
                </td>
                <td
                  class="table-item text-center"
                  v-bind:style="{
                    color:
                      settings_style.colors != undefined
                        ? settings_style.colors[4].color_value + ' !important'
                        : 'white',
                  }"
                >
                  4
                </td>
                <td
                  class="table-item text-center font-weight-bold strong-text"
                  v-bind:style="{
                    color:
                      settings_style.colors != undefined
                        ? settings_style.colors[3].color_value + ' !important'
                        : 'white',
                  }"
                >
                  $200
                </td>
              </tr>
              <tr>
                <td class="p-3 pr-2" colspan="4">
                  <div class="d-flex align-items-start">
                    <div class="d-flex flex-column ml-3">
                      <span style="font-size:18px;" class="d-block font-weight-bold strong-text" v-bind:style="{ color: settings_style.colors != undefined ? settings_style.colors[3].color_value + ' !important' : 'white',}">Ejemplo de texto</span>
                      <div v-bind:style="{ color: settings_style.colors != undefined ? settings_style.colors[4].color_value + ' !important' : 'white', }">Esta es la forma en la que tu cliente verá un texto agregado a la cotización. Los textos pueden ir ya sea arriba o debajo de un producto e inclusive después del total.</div>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
            <div class="align-self-end" style="">
              <table class="table-body-two mt-5">
                <tr>
                  <th
                    class="px-4 strong-text"
                    v-bind:style="{
                      color:
                        settings_style.colors != undefined
                          ? settings_style.colors[3].color_value + ' !important'
                          : 'white',
                    }"
                  >
                    Subtotal:
                  </th>
                  <td
                    class="px-4 text-right"
                    v-bind:style="{
                      color:
                        settings_style.colors != undefined
                          ? settings_style.colors[4].color_value + ' !important'
                          : 'white',
                    }"
                  >
                    200
                  </td>
                </tr>
                <tr>
                  <th
                    class="px-4 strong-text"
                    v-bind:style="{
                      color:
                        settings_style.colors != undefined
                          ? settings_style.colors[3].color_value + ' !important'
                          : 'white',
                    }"
                  >
                    IVA 16%:
                  </th>
                  <td
                    class="px-4 text-right"
                    v-bind:style="{
                      color:
                        settings_style.colors != undefined
                          ? settings_style.colors[4].color_value + ' !important'
                          : 'white',
                    }"
                  >
                    2000
                  </td>
                </tr>
                <tr
                  class="principal-row-table"
                  v-bind:style="{
                    backgroundColor:
                      settings_style.colors != undefined
                        ? settings_style.colors[0].color_value
                        : 'white',
                  }"
                >
                  <th class="px-4 py-2">TOTAL:</th>
                  <th class="px-4 py-2 text-right">230</th>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import data from "@/mixins/data";
import filters from "@/mixins/filters";
import LabelCommission from "@/components/pdf/body/LabelCommission";
import LabelDiscount from "@/components/pdf/body/LabelDiscount";
import LightBox from "@/components/helpers/Lightbox";

export default {
  mixins: [filters, data],
  components: {
    lightbox: LightBox,
    LabelCommission,
    LabelDiscount,
  },

  mounted() {
    if (this.quote_data != undefined) {
      this.quote_data.items.forEach((element) => {
        this.items.push(element);
      });
    }
  },

  computed: {
    optionals() {
      return this.products.filter((item) => item.optional.active).length;
    },
    optionalsSelected() {
      return this.products.filter(
        (item) => item.optional.select == true && item.optional.active == true
      ).length;
    },
    products() {
      return this.items.filter((item) =>
        item.suscription != undefined ? !item.suscription.active : false
      );
    },
    subtotal() {
      return (
        this.products.reduce((sum, product) => {
          if (!product.optional.active || product.optional.select) {
            return (sum += parseFloat(product.total));
          } else {
            return (sum += 0);
          }
        }, 0) || 0
      );
    },
    justTaxes() {
      if (this.quote_data.tax) {
        return (
          this.products.reduce((sum, product) => {
            if (!product.optional.active || product.optional.select) {
              return product.tax
                ? (sum +=
                    product.total *
                    (1 - this.quote_data.discount / 100) *
                    (this.quote_data.tax_value / 100))
                : sum;
            } else {
              return (sum += 0);
            }
          }, 0) || 0
        );
      } else {
        return 0;
      }
    },
    justDiscount() {
      return this.subtotal * (this.quote_data.discount / 100);
    },
    getTotal() {
      return this.subtotal - this.justDiscount + this.justTaxes;
    },

    hasProducts() {
      return this.products.length > 0;
    },

    suscriptions() {
      return this.items.filter(
        (item) =>
          item.type === "producto" &&
          item.suscription.frequency != null &&
          item.optional.select == true
      );
    },
    discountItems() {
      return (
        this.products.reduce((sum, product) => {
          if (!product.optional.active || product.optional.select) {
            return (sum += parseFloat(
              (product.price * product.discount.amount) / 100
            ));
          } else {
            return (sum += 0);
          }
        }, 0) || 0
      );
    },
  },

  data() {
    return {
      items: [],
    };
  },

  props: {
    settings_style: {
      required: true,
    },
    quote_data: {
      type: Object,
    },
  },

  methods: {
    getSuscriptionTotal(amount, hasTax) {
      const tax = hasTax ? 1 + this.quote_data.tax_value / 100 : 1;
      const discount =
        this.quote_data.discount > 0 ? 1 - this.quote_data.discount / 100 : 1;
      return amount * discount * tax;
    },
    calculate(string, field, index) {
      let item = this.items[index];

      try {
        let value = eval(string);
        field === "qty"
          ? (item.quantity.amount = parseFloat(value))
          : (item.price = parseFloat(value));
      } catch (error) {
        return parseFloat(string);
      }
      this.setTotal(index);
    },
    /* Setear total */
    setTotal(index) {
      let item = this.items[index];
      item.total = parseFloat(this.getProductTotal(index));
    },
    /* Obtener total de un producto */
    getProductTotal(index) {
      let item = this.items[index];
      return parseFloat(
        item.quantity.amount *
          item.price *
          (item.commission.active ? 1 + item.commission.amount / 100 : 1) *
          (item.discount.active ? 1 - item.discount.amount / 100 : 1)
      ).toFixed(2);
    },
  },
};
</script>
